const r = (t) => t ? Object.fromEntries(Object.entries(t).filter(([e]) => e.startsWith("x-"))) : {};
export {
  r as getXKeysFromObject
};
